var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.78125,
    width: 104.219,
    height: 104.219,
    rx: 9.8016,
    fill: "#231671",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.3333 56.1133C65.3333 54.2799 63.8333 52.7799 62 52.7799H52C50.1667 52.7799 48.6667 54.2799 48.6667 56.1133C48.6667 57.9466 50.1667 59.4466 52 59.4466H62C63.8333 59.4466 65.3333 57.9466 65.3333 56.1133ZM52 32.7799C64.8633 32.7799 75.3333 43.2499 75.3333 56.1133C75.3333 68.9766 64.8633 79.4466 52 79.4466C39.1367 79.4466 28.6667 68.9766 28.6667 56.1133C28.6667 43.2499 39.1367 32.7799 52 32.7799ZM52 26.1133C35.43 26.1133 22 39.5433 22 56.1133C22 72.6833 35.43 86.1133 52 86.1133C68.57 86.1133 82 72.6833 82 56.1133C82 39.5433 68.57 26.1133 52 26.1133ZM55.3333 46.1133C55.3333 44.2799 53.8333 42.7799 52 42.7799C50.1667 42.7799 48.6667 44.2799 48.6667 46.1133V56.1133C48.6667 57.9466 50.1667 59.4466 52 59.4466C53.8333 59.4466 55.3333 57.9466 55.3333 56.1133V46.1133ZM52 39.4466C61.19 39.4466 68.6667 46.9233 68.6667 56.1133C68.6667 65.3033 61.19 72.7799 52 72.7799C42.81 72.7799 35.3333 65.3033 35.3333 56.1133C35.3333 46.9233 42.81 39.4466 52 39.4466ZM52 36.1133C46.6957 36.1133 41.6086 38.2204 37.8579 41.9711C34.1071 45.7219 32 50.8089 32 56.1133C32 61.4176 34.1071 66.5047 37.8579 70.2554C41.6086 74.0061 46.6957 76.1133 52 76.1133C57.3043 76.1133 62.3914 74.0061 66.1421 70.2554C69.8929 66.5047 72 61.4176 72 56.1133C72 50.8089 69.8929 45.7219 66.1421 41.9711C62.3914 38.2204 57.3043 36.1133 52 36.1133Z",
    fill: "#231671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time_icon.452018548c0828fbaada3a46b9f1bbf7.svg";
export { ForwardRef as ReactComponent };